import { AlertCircle } from 'lucide-react';

import type { ExameRecente } from '@/api/generated/model';
import { EstadoVazio } from '@/shared/components/estados';

/**
 * Tabela HTML nativa, como na V1 — o `ui/table` não é usado aqui.
 *
 * ⚠️ **O.S. e situação do exame não aparecem** (ajuste de Ago/2026). Os dois
 * campos continuam vindo do servidor: o pedido foi de exibição, não de dado, e
 * a lista de exames é a mesma consumida por quem precisa da O.S. no suporte.
 */
export function ExamesRecentesTabela({ exames }: { exames: ExameRecente[] }) {
  if (exames.length === 0) {
    return (
      <EstadoVazio
        icone={AlertCircle}
        titulo="Nenhum exame encontrado"
        descricao="Os exames aparecem aqui conforme forem lançados."
      />
    );
  }

  return (
    // O scroll fica neste container, não no body — tabela larga não pode fazer
    // a página inteira rolar na horizontal.
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="text-left text-xs font-semibold text-muted-foreground uppercase tracking-wide border-b border-brand/10">
            <th className="px-6 py-3">Paciente</th>
            <th className="px-6 py-3">Exames</th>
            <th className="px-6 py-3">Responsável</th>
            <th className="px-6 py-3">Data</th>
          </tr>
        </thead>
        <tbody>
          {exames.map((exame) => (
            <tr key={exame.exameId} className="border-b border-brand/5 hover:bg-muted/40">
              <td className="px-6 py-3 font-medium text-foreground">{exame.pacienteNome}</td>
              <td className="px-6 py-3 text-muted-foreground">
                {exame.examesLabel}
                {exame.quantidade > 1 && (
                  <span className="ml-1 text-xs">(+{exame.quantidade - 1})</span>
                )}
              </td>
              {/* `responsavel` é o TUTOR do pet — o mesmo nome que a ficha do
                  paciente mostra sob "Responsável". Travessão quando o
                  paciente não tem tutor, como no `PacienteCard`. */}
              <td className="px-6 py-3 text-muted-foreground">{exame.responsavel ?? '—'}</td>
              <td className="px-6 py-3 text-muted-foreground">
                {new Date(exame.data).toLocaleDateString('pt-BR')}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
